import store from '@/store'

export default [
  {
    path: '/admin/stock-transfers',
    name: 'stock-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-transfer/index.vue')
  },
  {
    path: '/admin/stock-transfers/create',
    name: 'stock-transfer-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-transfer/create.vue')
  },
  {
    path: '/admin/stock-transfers/:id/edit',
    name: 'stock-transfer-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-transfer/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stock/stockTransfer/find', to.params.id)
      next()
    }
  }
]
